export default __webpack_public_path__ + "a813871be8726018fa2e6e7316856e9e.ttf";